import { Controller } from 'react-hook-form';
import type { IIdentifiersForm } from '../IdentifiersForm';
import type { Control } from 'react-hook-form';
import FormLabel from './FormLabel';
import SearchDropDown from './SearchDropDown';
import { ErrorText } from '@buoyhealth/common.buoy-input';

interface IFormElementProps extends React.InputHTMLAttributes<HTMLInputElement> {
  control: Control<IIdentifiersForm, any>;
  name: 'sex';
  label: string;
  errorMessage?: string;
}

const SEX_OPTIONS = [
  { name: 'Female', token: 'f' },
  { name: 'Male', token: 'm' },
];

const SexInput = ({ control, name, label, errorMessage, required }: IFormElementProps) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        const { ref: inputRef, ...fieldProps } = field;
        return (
          <div>
            <FormLabel
              name={name}
              label={label}
              tooltipText="We recognize that not everyone identifies as female or male, so we're working to incorporate more gender identities into Buoy's algorithm. For now, enter your sex at birth to continue."
            />
            <SearchDropDown
              {...fieldProps}
              options={SEX_OPTIONS}
              placeholder="Select sex at birth"
              autocomplete="sex"
              onChange={(_event, value) => {
                fieldProps.onChange(value.token);
              }}
            />
            <ErrorText
              show={!!fieldState.error}
              message={errorMessage || 'Select an option above'}
            />
          </div>
        );
      }}
      rules={{ required }}
    />
  );
};

export default SexInput;
